import { useEffect } from "react";
import "./AboutModal.css";
import { X } from "lucide-react";

const AboutModal = ({ show, onClose }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  return (
    <>
      {/* BACKDROP */}
      <div
        className={`modal-backdrop-custom ${show ? "show" : ""}`}
        onClick={onClose}
      ></div>

      {/* SLIDE MODAL */}
      <div className={`about-modal ${show ? "open" : ""}`}>
        <div className="modal-content-wrapper">
          <div className="modal-header-custom">
            <h2>About Us</h2>

            <button className="close-btn" onClick={onClose}>
              <X size={22} />
            </button>
          </div>
          <hr />

          <div className="modal-body">
            <p>
              XP in the name represents our intent to be fast (at express speed)
              while we encourage our rezspondent to feel free to express. As the
              name suggests, the platform also encourages administrative
              convenience coupled with the speed of management.
            </p>

            <p>
              There are many survey platforms in the market. However, how does
              XPSurvey differ from the rest of the players? Well, to actually
              know the difference its best to experience us. Some of our key
              differentiators from the market are:
            </p>

            <ul>
              <li>Easy to design surveys</li>
              <li>
                User friendly for all the user types - designer, administrator
                or the surveyee
              </li>
              <li>
                Gives lot of administrative convenience like followup,
                scheduling, customised content etc.
              </li>
              <li>Maintain confidentiality of respondent</li>
              <li>Reports customizable as per need</li>
              <li>
                Can be used for voting/polling, with customizable features
              </li>
              <li>Can enable real-time polling</li>
            </ul>

            <p>
              The best part of the platform is that it is extremely customizable
              as per user needs; of course, while being cost effective.
            </p>

            <p>
              Developed by an experienced team of HR, IT, Finance, Marketing &
              Sales professionals, this platform is designed keeping the ground
              realities, challenges and expectations in mind. The tearing need
              of having an adminstrative friendly tool to dipstick, sense,
              capture, gauge or monitor client, employee, customer or partner's
              needs, emotions, engagement, feedback or views was considered
              while designing the platform.
            </p>

            <p>
              Well, having said that we can never boast of having the complete
              solution for you - We are still learning - learning your needs,
              listening to you; and while we are doing so, we are still
              improvising continually.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutModal;
